module.exports = __webpack_public_path__ + "img/22.47fa4d08.png";